"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTypes = void 0;
var TaskTypes;
(function (TaskTypes) {
    TaskTypes["RunInSingleVM"] = "single-vm";
    TaskTypes["ExtractAudios"] = "extract-audios";
    TaskTypes["ExtractVideos"] = "extract-videos";
    TaskTypes["ExtractAudioPreviews"] = "extract-audio-previews";
    TaskTypes["GenerateParticipantClip"] = "generate-participant-clip";
    TaskTypes["Cleanup"] = "cleanup";
    TaskTypes["GenerateParticipantsZip"] = "generate-participants-zip";
    TaskTypes["DeleteParticipantsZip"] = "delete-participants-zip";
    TaskTypes["GenerateParticipantsVgZip"] = "generate-participants-vg-zip";
    TaskTypes["DeleteParticipantsVgZip"] = "delete-participants-vg-zip";
    TaskTypes["DeleteParticipantsData"] = "delete-participants-data";
    TaskTypes["VgDownloadGenericAssets"] = "vg-download-generic-assets";
    TaskTypes["VgGenerateParticipantClip"] = "vg-generate-participant-clip";
    TaskTypes["VgGenerateVirtualCeremony"] = "vg-generate-virtual-ceremony";
    TaskTypes["VgCleanup"] = "vg-cleanup";
    TaskTypes["VgGeneratePreRollVideo"] = "vg-generate-pre-roll-video";
    TaskTypes["VgGeneratePostRollVideo"] = "vg-generate-post-roll-video";
    TaskTypes["VgGenerateVirtualCeremonyStandalone"] = "vg-generate-virtual-ceremony-standalone";
    TaskTypes["TransformFile"] = "transform-file";
    TaskTypes["ConvertVideoToMp4"] = "convert-video-to-mp4";
    TaskTypes["AfterEffectsDownloadTemplate"] = "after-effects-download-template";
    TaskTypes["Vg2DownloadGeneratorJobAssetsAndTemplate"] = "vg2-download-generator-job-assets-and-template";
    TaskTypes["Vg2GenerateParticipantClip"] = "vg2-generate-participant-clip";
    TaskTypes["Vg2GenerateParticipantClipStandalone"] = "vg2-generate-participant-clip-standalone";
    TaskTypes["Vg2Cleanup"] = "vg2-cleanup";
    TaskTypes["Vg2GenerateParticipantClipForCeremony"] = "vg2-generate-participant-clip-for-ceremony";
    TaskTypes["Vg2GeneratePreRollVideo"] = "vg2-generate-pre-roll-video";
    TaskTypes["Vg2GeneratePostRollVideo"] = "vg2-generate-post-roll-video";
    TaskTypes["Vg2GenerateCeremonyClip"] = "vg2-generate-ceremony-clip";
    TaskTypes["Vg2GenerateVirtualCeremonyStandalone"] = "vg2-generate-virtual-ceremony-standalone";
    TaskTypes["Vg2GenerateChapterClip"] = "vg2-generate-chapter-clip";
    TaskTypes["Vg2DeleteDummyParticipant"] = "vg2-delete-dummy-participant";
    TaskTypes["Vg2DeletePreviewDummyParticipant"] = "vg2-delete-preview-dummy-participant";
    TaskTypes["UploadCeremonyVideoToYoutube"] = "upload-ceremony-video-to-youtube";
    TaskTypes["ValidateParticipantAudiosZipFile"] = "validate-participant-audios-zip-file";
    TaskTypes["ImportParticipantAudios"] = "import-participant-audios";
    TaskTypes["GenerateMediaThumbnail"] = "generate-media-thumbnail";
    TaskTypes["ClipParticipantVideo"] = "clip-participant-video";
    TaskTypes["GenerateParticipantsSlidesZip"] = "generate-slides-zip";
    TaskTypes["UploadVideoToAzureFromUrl"] = "vg2-upload-video-to-azure-from-url";
    TaskTypes["UploadVideoFromUrlAndProcessClip"] = "vg2-upload-video-from-url-and-process-clip";
    TaskTypes["GenerateParticipantsNameReadingZip"] = "generate-name-reading-zip";
    TaskTypes["GenerateScanAndPlayAudioZip"] = "generate-scan-and-play-zip";
    TaskTypes["MoveTemplateAssetsToS3"] = "move-template-assets-to-s3";
    TaskTypes["GenerateSeasonParticipantsZip"] = "generate-season-participants-zip";
    TaskTypes["DeleteSeasonParticipantsZip"] = "delete-season-participants-zip";
    TaskTypes["GenerateSeasonParticipantsSlidesZip"] = "generate-season-slides-zip";
    TaskTypes["ConvertVideoToMp3"] = "convert-video-to-mp3";
    TaskTypes["ProcessVideoAndGenerateTranscript"] = "process-and-generate-transcript";
    TaskTypes["CropVideoByTime"] = "crop-video-by-time";
})(TaskTypes = exports.TaskTypes || (exports.TaskTypes = {}));
//# sourceMappingURL=task-types.js.map